import type { QuickSuggestion, ContactCTA } from '@/types/chatbot'

/**
 * Quick suggestion buttons shown when the chat is empty.
 * Each entry uses i18n translation keys for label and message.
 */
export const quickSuggestions: QuickSuggestion[] = [
  {
    id: 'services',
    labelKey: 'chatbot.suggestions.services',
    messageKey: 'chatbot.suggestions.servicesMessage',
  },
  {
    id: 'quote',
    labelKey: 'chatbot.suggestions.quote',
    messageKey: 'chatbot.suggestions.quoteMessage',
  },
  {
    id: 'products',
    labelKey: 'chatbot.suggestions.products',
    messageKey: 'chatbot.suggestions.productsMessage',
  },
  {
    id: 'contacts',
    labelKey: 'chatbot.suggestions.contacts',
    messageKey: 'chatbot.suggestions.contactsMessage',
  },
]

/**
 * Contact CTA buttons shown below each assistant message.
 * Clicking copies the value to clipboard.
 */
export const contactCTAs: ContactCTA[] = [
  {
    id: 'email',
    labelKey: 'chatbot.cta.email',
    value: 'info@simertec.it',
  },
  {
    id: 'phone',
    labelKey: 'chatbot.cta.phone',
    value: '+39 0522 1965021',
  },
]
